(function () {
    $(document).ready(function () {
      $(".student-stories__text").slick({
        slidesToShow: 1,
        arrows: false,
        adaptiveHeight: true,
        asNavFor: ".student-stories__controls",
      });
  
      $(".student-stories__controls").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        variableWidth: true,
        draggable: true,
        arrows: false,
        asNavFor: ".student-stories__text",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  
      if ($(".student-stories__controls").length) {
        // Find the parent div with the class band and add a new class to it
        $(".student-stories__controls")
          .closest(".band")
          .addClass("band--student-stories");
      }
  
      /**
        Suppress cloned slides from keyboard and screen reader access.
        Slick duplicates slides in the DOM when infinite = true. These clones
        are purely visual — they should never receive focus or be announced.
        This must be re-run after each slide change since Slick rebuilds clones.
       */
      function suppressClones() {
        $(".student-stories__controls, .student-stories__text")
          .find(".slick-cloned .student-photo, .slick-cloned .student-story")
          .attr("tabindex", "-1")
          .attr("aria-hidden", "true");
      }

      /**
        Sync ARIA state with the currently active story.
        Note: Slick clones slides when infinite = true. We target only
        non-cloned slides to avoid duplicate "active" buttons/panels.
       */
      function syncAriaState(activeIndex) {
        
        activeIndex = parseInt(activeIndex, 10);

        if (isNaN(activeIndex)) activeIndex = 0;
  
        // Get our actual buttons and panels
        var $thumbButtons = $(".student-stories__controls").find(
          ".slick-slide:not(.slick-cloned) .student-photo"
        );
        var $panels = $(".student-stories__text").find(
          ".slick-slide:not(.slick-cloned) .student-story"
        );
  
        // If markup doesn't match expectations, do nothing.
        if (!$thumbButtons.length || !$panels.length) return;
  
        // Update thumb button states
        $thumbButtons.each(function (idx) {
          var isActive = idx === activeIndex; // true when this button’s position matches the currently active slide index
          $(this)
            .attr("aria-pressed", isActive ? "true" : "false")
            .attr("aria-current", isActive ? "true" : "false");
        });
  
        // Update which panel is exposed to screen readers
        $panels.each(function (idx) {
          $(this).attr("aria-hidden", idx === activeIndex ? "false" : "true");
        });
      }
  
      // Initialize state using Slick's current slide (don’t assume it's 0).
      var slickInstance = $(".student-stories__text").slick("getSlick");
      syncAriaState(
        slickInstance && typeof slickInstance.currentSlide === "number"
          ? slickInstance.currentSlide
          : 0
      );
  
      // Suppress cloned slides on init.
      suppressClones();
  
      // Keep ARIA state in sync whenever the story slider changes
      // (covers click, swipe/drag, and programmatic nav).
      $(".student-stories__text").on("afterChange", function (event, slick, currentSlide) {
        syncAriaState(currentSlide);
        // Re-suppress clones since Slick rebuilds them after each slide change.
        suppressClones();
      });
    });
  })(this);
